
<template>

  <div class="col-lg-12" style="padding:20px 20px 20px 30px;">
    <div class="main-card mb-3 card">
      <div class="card-body">
        <h5 class="card-title" >진도현황
          <div class="sub_title"
          style="margin-bottom: 20px; color: #333; font-size: 13px; border: 1px solid #ccc; background: #f8f8f8; height: 30px; text-align: right; position: absolute; right: 20px; top: 10px; padding: 2px 10px;">
              진도관리 → 진도현황
          </div>
        </h5>
        <query-grid :config="config_S" ref="qg">
          <template #resultactions>
            <p style="font-size:14px; ">
              <div style="float:left; padding-left:10px;"><div class="progress" style="width:30px;">
    <div class="progress-bar progress-bar-striped" role="progressbar" style="width: 30px;" aria-valuenow="10" aria-valuemin="0" aria-valuemax="100"></div>
  </div></div>

  <div style="float:left; line-height:15px; margin-bottom:10px;">를 클릭하시면 진도처리(ADMIN)를 하실 수 있습니다.</div>
           </p>
          </template>
          <template #items="props">
            <tr v-for="(record, i) in props.records" v-bind:key="record.intNo">
              <td scope="col"><input type="checkbox" v-model="record.checked"></td>
              <td style="text-align:center;" v-if="this.$root.guiPerm != 'CLASS' && this.$root.guiPerm != 'ENTERPRISE'" >
                <Business v-if="record.t2" :biz="record.t2" /></td>
              <td style="text-align:center;"> <Business v-if="record.t1" :biz="record.t1" /></td>
              <td style="text-align:center;">{{ record.username }}</td>
              <td style="text-align:center;"><Student :student="{'id': record.intMemberID, 'name': record.name}" /></td>
              <td style="text-align:center;">{{ record.Step }}</td>
              <td style="text-align:center;">{{ record.strSubject }}</td>
              <td data-bs-toggle="modal"  style="cursor:pointer;" data-bs-target=".ModalAdm" @click="getAccDe(record.id, record.strGrade, record.Step, record.strSubject) ; getCurrent(true, record.intMemberID, record.strGrade, record.Step, record.strSubject, record.name, record.business, record.intDone, record.intTotal, record.t1)" >{{ record.intDone }} / {{ record.intTotal }} <div class="progress" tyle="cussor:pointer;">
                  <div class="progress-bar progress-bar-striped" role="progressbar" style="cursor: pointer;"
                    :style="{'width': (record.intDone/record.intTotal*100) + '%'}" aria-valuenow="10" aria-valuemin="0"
                    aria-valuemax="100"></div>
                </div>
              </td>
              <td style="text-align:center; font-size:12px;">{{ record.datAssign.substr(2, 8) }}</td>
              <td >
                <template v-if="record.TEST1_S" ><span @click="viewAT(record.TEST1)"  class="btn btn-success btn-sm" style="padding:1px 2px;font-size:12px; display:inline;">{{ record.TEST1_S }}점</span>
                  <button @click="onDel('1', record.ATint, record.TEST1)" class="btn btn-warning btn-sm" style="padding:1px 2px;font-size:12px; display:inline;">RE</button>
                  <button class="btn btn-danger btn-sm" data-bs-toggle="modal" data-bs-target=".progress_report" style="cursor:pointer; padding:1px 2px; font-size:12px;" @click="onReport('1st', record.intMemberID, record.strGrade, record.Step, record.strSubject, record.name, record.engName, record.t1, record.tutor_name, record.datAssign.substr(0, 10), record.TEST1_D, record.TEST1_S, record.intTotal)" >Report</button>
                  <br /><span>({{ record.TEST1_D.substr(2, 8) }})</span>
                </template>
              </td>
              <td >
                <template v-if="record.TEST2_S" ><span @click="viewAT(record.TEST2)"  class="btn btn-success btn-sm" style="padding:1px 2px;font-size:12px; display:inline;">{{ record.TEST2_S }}점</span>
                  <button @click="onDel('2', record.ATint, record.TEST2)" class="btn btn-warning btn-sm" style="padding:1px 2px;font-size:11px; display:inline;">RE</button>
                  <button class="btn btn-danger btn-sm" data-bs-toggle="modal" data-bs-target=".progress_report" style="cursor:pointer; padding:1px 2px; font-size:12px;" @click="onReport('2nd', record.intMemberID, record.strGrade, record.Step, record.strSubject, record.name, record.engName, record.t1, record.tutor_name, record.datAssign.substr(0, 10), record.TEST2_D, record.TEST2_S, record.intTotal)" >Report</button>
                  <br /><span>({{ record.TEST2_D.substr(2, 8) }})</span>
                </template>
              </td>
              <td >
                <template v-if="record.TEST3_S" ><span @click="viewAT(record.TEST3)"  class="btn btn-success btn-sm" style="padding:1px 2px;font-size:12px; display:inline;">{{ record.TEST3_S }}점</span>
                  <button @click="onDel('3', record.ATint, record.TEST3)" class="btn btn-warning btn-sm" style="padding:1px 2px;font-size:11px; display:inline;">RE</button>
                  <button class="btn btn-danger btn-sm" data-bs-toggle="modal" data-bs-target=".progress_report" style="cursor:pointer; padding:1px 2px; font-size:12px;" @click="onReport('3rd', record.intMemberID, record.strGrade, record.Step, record.strSubject, record.name, record.engName, record.t1, record.tutor_name, record.datAssign.substr(0, 10), record.TEST3_D, record.TEST3_S, record.intTotal)" >Report</button>
                  <br /><span>({{ record.TEST3_D.substr(2, 8) }})</span>
                </template>
              </td>
              <td><button class="btn btn-danger btn-sm"  data-bs-toggle="modal" data-bs-target=".view" @click="initQueryGrid(record.id)"><i class="fas fa-search"></i></button></td>
              <td>
                <template v-if="record.TEST1_S && record.TEST2_S && record.TEST3_S">
                  <button @click="onMission2(record.id, record.report_info)" class="btn btn-success btn-sm" style="line-height:14px; text-align:center;font-size:11px;">Complete<br/>

                  (<span v-if="record.datEnd" style="font-size:11px;">{{ record.datEnd.substr(2, 8) }}</span>)</button>

                </template>
              </td>
              <td>
                <template v-if="record.All_finish && record.TEST1_S && record.TEST2_S && record.TEST3_S">
                  <button @click="onMission(record.id, record.report_info)" class="btn btn-warning btn-sm" style="line-height:14px; text-align:center;font-size:11px;">Certifation<br />
  (<span v-if="record.datEnd" >{{ record.All_End.substr(2, 8) }}</span>)
                  </button>


                </template>
              </td>
              <td>
                <button class="btn btn-danger btn-sm" data-bs-toggle="modal" data-bs-target=".bd-example-modal-lg"
                  @click="getCurrent(true, record.intMemberID, record.strGrade, record.Step, record.strSubject, record.name, record.business, record.intDone, record.intTotal, record.t1)" style="font-size:11px;"><i class="fa-solid fa-plus"></i></button>
              </td>
            </tr>
          </template>
          <template #actions>
          <button class="btn btn-danger" data-bs-toggle="modal" data-bs-target=".homework" @click="Getclasslist(true)">미국학교 숙제부여</button>
          </template>
        </query-grid>
<!--
  :data-bs-target="'#ModalAdm' + TbtnId"
                            @click="getAccDe
  ReportData = {
            "strGrade": strGrade,
            "strCourse": strCourse,
            "strSubject": strSubject,
            "intMemberID": intMemberID,
            "s_name": s_name,
            "e_name": e_name,
            "s_class": s_class,
            "t_name": t_name,
            "s_date": s_date,
            "e_date": e_date,
            "AT_Point": AT_Point,
            "intTotal": intTotal

  this.total_A = response.data.total_A;
  this.total_L = response.data.total_L;
  this.total_AW = response.data.total_AW;
  this.total_LW = response.data.total_LW;
-->
                        <!-- Progress Report -->



                        <div class="modal fade progress_report" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel"
                          aria-hidden="true">
                          <div class="modal-dialog modal-lg">
                            <div class="modal-content">

                              <table class="table p_report" style="border:0px; font-size:20px!important;" id="printThis">
                                <tbody>
                                  <tr>
                                    <td colspan="5" style="border:0px; padding:0px 3px;">
                                     <img style="width: 100%;" src="https://mypathkr.com/img/p-r-title.png"/>
                                    </td>
                                  </tr>
                                  <tr>
                                    <th colspan="1">Student's English Name</th>
                                    <td colspan="2">{{ ReportData.e_name }}</td>
                                    <th colspan="1">Korean Name</th>
                                    <td colspan="1">{{ ReportData.s_name }}</td>
                                  </tr>
                                  <tr>
                                    <th colspan="1">Date</th>
                                    <td colspan="2">{{ ReportData.s_date.substr(0, 10) }} ~ {{ ReportData.e_date.substr(0, 10) }}</td>
                                    <th colspan="1">Level</th>
                                    <td colspan="1"><span class="btn btn-success btn-sm">{{ ReportData.strGrade }}</span></td>

                                  </tr>
                                  <tr>
                                    <th>Class</th>
                                    <td colspan="4"  v-if="ReportData.s_class">{{ ReportData.s_class.name}}({{ ReportData.t_name }})</td>



                                  </tr>

                                  <tr>
                                    <th rowspan="3" style="background:#103674 !important; color:#fff;"><span style="color:#d61518;">■</span> Progress Report</th>
                                    <th colspan="4" style="background:#3e5a89 !important; color:#fff;">Language Course</th>
                                  </tr>
                                  <tr>
                                    <th colspan="2" style="background:#6d82a6 !important; color:#fff;">Main Subject</th>
                                    <th colspan="2" style="background:#6d82a6 !important; color:#fff;">{{ ReportData.step }}</th>
                                  </tr>
                                  <tr>
                                    <td colspan="2">{{ ReportData.strSubject }}</td>
                                    <td colspan="2">{{ ReportData.intTotal / 3 }} / {{ ReportData.intTotal / 3 }}</td>
                                  </tr>
                                  <tr>
                                    <th rowspan="2" style="background:#103674 !important; color:#fff;"><span style="color:#ffba00;">■</span> Achievement Test</th>
                                    <th colspan="2" style="background:#3e5a89 !important; color:#fff;">Main Subject</th>
                                    <th colspan="2" style="background:#3e5a89 !important; color:#fff;">{{ ReportData.step }}</th>
                                  </tr>
                                  <tr>
                                    <td colspan="2">{{ ReportData.strSubject }}</td>
                                    <td colspan="3" style="color:#d61518; font-size:20px; font-weight:bold; vertical-align: middle;">{{ ReportData.AT_Point }}점</td>
                                  </tr>
                                  <tr>
                                    <th rowspan="3" style="background:#103674 !important; color:#fff;"><span style="color:#40a100;">■</span> Homework Report</th>
                                    <th colspan="2" style="background:#3e5a89 !important; color:#fff;">American School (미국학교학습)</th>
                                    <th colspan="2" style="background:#3e5a89 !important; color:#fff;">Language Training (언어훈련관)</th>
                                  </tr>
                                  <tr>
                                    <td>Assigned</td>
                                    <td>{{ total_A }}</td>
                                    <td>Assigned</td>
                                    <td>{{ total_L }}</td>
                                  </tr>
                                  <tr>
                                    <td>Completed</td>
                                    <td>{{ total_AW }}</td>
                                    <td>Completed</td>
                                    <td>{{ total_LW }}</td>
                                  </tr>

                                  <tr>
                                    <td colspan="5">
                                        <Bar
                  :chart-options="chartOptions"
                  :chart-data="chartData"
                  chart-id="bar-chart"
                  dataset-id-key="label"
                  width="200" height="80"
                />




                                                      </td>

                                  </tr>
                                  <tr>
                                    <th>Teacher's Evaluation</th>
                                    <td colspan="4">

                                        <label>
                                          <input type="radio" name="Evaluation" value="라디오" id="Evaluation_0" style="v-align:middle;">
                                          Outstanding</label>&nbsp;&nbsp;

                                        <label>
                                          <input type="radio" name="Evaluation" value="라디오" id="Evaluation_1">
                                          Excellent</label>&nbsp;&nbsp;

                                        <label>
                                          <input type="radio" name="Evaluation" value="라디오" id="Evaluation_2">
                                          Good</label>&nbsp;&nbsp;
                                          <label>
                                          <input type="radio" name="Evaluation" value="라디오" id="Evaluation_3">
                                          Not Bad</label>&nbsp;&nbsp;
                                          <label>
                                          <input type="radio" name="Evaluation" value="라디오" id="Evaluation_4">
                                          Bad</label>

                                      </td>
                                  </tr>
                                  <tr>
                                    <th>Teacher's Comment</th>
                                    <td colspan="4" ><textarea style="width:95%; border:1px solid #ccc; height:80px;"></textarea></td>
                                  </tr>
                                </tbody>
                              </table>

                              <div class="modal-footer flex_center">
                                <button type="button" class="btn btn-danger"   @click="printIt()">출력</button>
                                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">닫기</button>

                              </div>
                            </div>

                          </div>
                        </div>


        <div class="flex_center">
          <!-- Modal -->
          <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
            aria-hidden="true">
            <div class="modal-dialog" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel">Modal title</h5>
                  <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                  <p class="mb-0">Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an
                    unknown printer took a galley of type and scrambled.</p>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                  <button type="button" class="btn btn-primary">Save changes</button>
                </div>
              </div>
            </div>
          </div>

          <!-- Large modal -->
          <div class="modal fade bd-example-modal-lg" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel"
            aria-hidden="true">
            <div class="modal-dialog modal-lg">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLongTitle">숙제부여</h5>
                  <!-- 리스트에서 검색한 값들이 셀렉받스에 기본값으로 들어가 있어야함 -->
                </div>
                <div class="modal-body">학습해야할 진도/숙제를 부여할 수 있습니다.
                  <table class="table">
                    <tr>
                      <td class="th_bg">
                        클래스
                      </td>
                      <td>
                        <div class="input-group mb-12">
                          <span id="inputGroupSelect01" class="not_select">{{ selData.s_class }}</span>




                        </div>
                      </td>
                      <td class="th_bg">
                        이름
                      </td>
                      <td>
                        <div class="input-group mb-12">
                          <span id="inputGroupSelect01" class="not_select">{{ selData.s_name }}</span>


                        </div>
                      </td>
                      <td class="th_bg">
                        Grade
                      </td>
                      <td>
                        <div class="input-group mb-12">
                          <span id="inputGroupSelect01" class="not_select">{{ selData.strGrade }}</span>


                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td class="th_bg">
                        Grade2
                      </td>
                      <td>
                        <div class="input-group mb-12">
                          <span id="inputGroupSelect01" class="not_select">{{ selData.strCourse }}</span>

                        </div>
                      </td>
                      <td class="th_bg">
                        Subject
                      </td>
                      <td>
                        <div class="input-group mb-12">
                          <span id="inputGroupSelect01" class="not_select">{{ selData.strSubject }}</span>

                        </div>
                      </td>
                      <td class="th_bg">
                        학습진행율
                      </td>
                      <td>

                        {{selData.intDone}}/{{selData.intTotals}}
                      </td>

                    </tr>
                    <tr>
                      <td class="th_bg">
                        기간
                      </td>
                      <td>
                        <input type="date" style="border:1px solid #ccc; background:#e0f2ff;" v-model="hopeStop" />
                      </td>


                      <td class="th_bg">
                        부여할 학습
                      </td>
                      <td>
                        <div class="input-group mb-12">
                          <div class="input-group-prepend">
                            <select v-model="sDay" class="custom-select flex_center" id="inputGroupSelect01"
                              style="background:#e0f2ff;">
                              <option v-for="(intTot, index) in selData.intTotals" :value="index + 1">
                                ~&nbsp;{{ index + 1 }} DAY
                              </option>
                            </select>
                          </div>
                        </div>
                      </td>
                      <td class="th_bg">

                      </td>
                      <td>
                        <div class="input-group mb-12">


                        </div>
                      </td>

                    </tr>
                  </table>
                  <div class="flex_center">
                    <button class="btn btn-danger" data-bs-toggle="modal" data-bs-target=".bd-example-modal-lg"
                      @click="PutCurrent(true)">숙제부여</button>
                  </div>

                  <span style="font-size:16px;">

                    숙제현황</span>

                  <table class="table" style="margin:4px;">
                    <thead>
                      <tr>

                        <th scope="col">No.</th>
                        <!--th scope="col">Class</th>
                    <th scope="col">Name</th-->
                        <th scope="col">Grade</th>
                        <th scope="col">Grade2</th>
                        <th scope="col">Subject</th>
                        <th scope="col">Homework</th>
                        <th scope="col">Assignment</th>
                        <th scope="col">Enddate</th>
                        <th scope="col">Result</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(history, index) in historys" v-bind:key="index">

                        <td scope="row">{{ index + 1 }}</td>
                        <td>{{ history.strGrade }}</td>
                        <td>{{ history.strCourse }}</td>
                        <td>{{ history.strSubject }}</td>
                        <td> ~ {{ history.strDay }} Day</td>
                        <td>{{ history.datAssign.substr(2, 8) }}</td>
                        <td><span v-if="history.datEnd">{{ history.datEnd.substr(0, 10) }}</span></td>
                        <td>
                          <template v-if="history.chrDone">
                            <span class="btn-success" style="padding:4px 8px; border-radius:4px;">Complete</span>
                          </template>
                          <template v-else>
                            <button class="btn btn-danger btn-sm" data-bs-toggle="modal"
                              data-bs-target=".bd-example-modal-lg" @click="DelCurrent(history.id)">Delete</button>
                          </template>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <!--10개씩 뿌리기 (페이지넘김 필요) -->
                  <div style="width:100%;  margin:0 auto;  text-align:center;">

                    <template v-for="i in Math.ceil(stotal / 10)" :key="i">
                      <button class="btn btn-sm btn-secondary"
                        @click="soffset=(i-1)*10;getCurrent('', selData.intMemberID, selData.strGrade, selData.strCourse, selData.strSubject, selData.s_name, selData.s_class, selData.intDone, selData.intTotals, selData.classselected)">{{ i }}</button>
                    </template>
                  </div>

                </div>
                <div class="modal-footer flex_center">
                  <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">닫기</button>

                </div>
              </div>
            </div>
          </div>


        </div>

      </div>
    </div>
  </div>



  <!-- 미국학교 숙제부여 modal -->
<div class="modal fade homework" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-modal="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLongTitle">미국학교 숙제부여</h5>
            </div>
            <div class="modal-body">

           <table class="table">
               <colgroup>
               <col style="width:25%;">
                   <col style="width:25%;">
                   <col style="width:25%;">
                   <col style="width:25%;">
               </colgroup>
             <tbody>
               <tr>
                 <th>숙제부여</th>
                 <td colspan="3" style="text-align:left;">


                      <select v-model="classselected" class="custom-select flex_center" style="width:170px;display:inline; margin:0 4px;  background:#f0fbff;" @change="viewStudent()">
                          <option disabled value="">Please select one</option>
                          <option v-for="classlist in classlists" :value="classlist.id">
                            {{ classlist.name }}
                          </option>
                        </select>
                        <select v-model="customValue" class="custom-select flex_center" style="width:100px;display:none;">
                          <option :value="0">ALL</option>
                          <option :value="1">개인별</option>
                        </select>
                        <input type="checkbox"
                                v-model="allChecked"
                                @click="checkedAll($event.target.checked)"
                        > 전체선택


                 </td>
               </tr>
               <tr>
                 <td colspan="4"><div class="select_homework" style="text-align:left;">
                   <ul v-if="customValue == '1'">
                    <li v-for="(studentlist, index) in studentlists" :value="studentlist.id" >
                      <input type="checkbox" name='tmpChkbox[]' :value="index" style="vertical-align:top;" v-model="studentlist.selected" @change="selected($event)"/>{{studentlist.name}}&nbsp;
                      <span style="font-size:11px;line-height:1px; padding:3px 6px; background:#00acea; color:#fff; border-radius:4px;">{{studentlist.level}}</span></li>
                  </ul>
                 </div>

                 </td>
               </tr>
               <tr>
                 <th>부여범위</th>
                 <td colspan="3" style="text-align:left;">
   <select class="custom-select flex_center" style="width:100px;display:inline; margin:0 4px;" @change="onChangeSGrade(true)" v-model="sslevel">
     <option value="">Grade</option>
<option value="GK">GK</option>
                    <option value="GK_1">GK_1</option>
                    <option value="GR1">GR1</option>
                    <option value="GR2">GR2</option>
                    <option value="GR3">GR3</option>
                    <option value="GR4">GR4</option>
                    <option value="GR5">GR5</option>
   </select>
   <select class="custom-select flex_center" style="width:100px;display:inline; margin:0 4px;" @change="onChangeSCourse(true)" v-model="ssCourse">
     <option value="">Grade_2</option>
    <option v-for="strCourse in sstrCourses" v-bind:key="strCourse.strCourse">
      {{ strCourse.strCourse }}</option>
  </select>
  <select class="custom-select flex_center" v-model="ssSubject" style="width:120px;display:inline; margin:0 4px;" @change="onChangeSSubject(true)">
    <option value="">Subject</option>
    <option v-for="strSubject in sstrSubjects" v-bind:key="strSubject.strSubject">
      {{ strSubject.strSubject }}</option>
  </select>
   <select class="custom-select flex_center" style="width:100px;display:inline; margin:0 4px;" v-model="ssday" >
    <option value="">Day</option>
    <option v-for="(intTot, index) in sstrdays.intTime" :value="index + 1">
      ~&nbsp;{{ index + 1 }} DAY
    </option>

   </select>
</td>
               </tr>
               <tr>
                 <th>시작일</th>
                 <td style="text-align:left;">  <input v-model="datAssign" type="date" style="width:140px; margin:0 4px;" /></td>
                 <th>종료일</th>
                 <td style="text-align:left;"><input v-model="datEnd" type="date" style="width:140px; margin:0 4px;" /></td>
               </tr>
               <tr>
                 <td colspan="4"><button class="btn btn-danger" data-bs-toggle="modal" data-bs-target=".homework" @click="AllPutCurrent(true)">미국학교 숙제부여</button></td>
               </tr>
             </tbody>
           </table>

           <p style="font-size:14px;">
           - <span style="font-weight:bold;">학생과정과 부여한 숙제과정이 다른 경우</span>에는 숙제를 수행할 수 없습니다.<br />
           - 일괄 숙제부여시에는 반드시 반 학생들의 레벨 및 차시를 확인후 부여해주세요.<br />
           - 기간이 지난 숙제의 경우 <span style="font-weight:bold;">기간후에 숙제를 완료해도 미완료(incomplete)</span>로 처리됩니다.<br />
           - 숙제부여후 <span style="font-weight:bold;">레벨을 변경하게 되면 해당 숙제는 기간이 남아 있어도 숙제기록실(Homework history)로 이동</span>하게 됩니다.<br />
           - 일괄부여의 경우는 해당반 학생들이<span style="font-weight:bold;"> 모두 동일레벨, 동일 차시일 경우</span>에만 사용해주시기 바랍니다.<br />
           </p>

            </div>
            <div class="modal-footer" style="border-top:none;">



                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">닫기</button>
            </div>
        </div>
    </div>
</div>
  <div class="modal fade view" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle">학습내용</h5>
          <!-- 리스트에서 검색한 값들이 셀렉받스에 기본값으로 들어가 있어야함 -->
        </div>
        <div class="modal-body">

<div style="text-align:left;">
<button class="btn btn-secondary view_tab" :class="{'active': currentPage == 'lang'}" @click="currentPage='lang'" style="border-right:none;">Language Course</button>

<button class="btn btn-secondary view_tab " :class="{'active': currentPage == 'regular'}" style="vertical-align: inherit; margin:0; border-right:none; " @click="currentPage='regular'">Regular Course</button>



<!--button class="btn btn-secondary btn-sm" style="vertical-align: inherit; ">Regular Course</button-->
<button class="btn btn-secondary view_tab " :class="{'active': currentPage == 'langTrain'}" style="vertical-align: inherit; margin:0; " @click="currentPage='langTrain'">Language Training</button>
<button class="btn btn-secondary view_tab " :class="{'active': currentPage == 'curri'}" style="vertical-align: inherit; margin:0; " @click="currentPage='curri'">Curriculum</button>
</div>
<div style="border-top:2px solid #ccc;">
  &nbsp;
</div>
<form class="form-inline">

<!--a onclick="reduceLength(1);return false;"><button class="btn btn-warning btn-sm" style="vertical-align: inherit; ">Today</button></a>
<a onclick="reduceLength(7);return false;"><button class="btn btn-warning btn-sm" style="vertical-align: inherit; ">D-7</button></a>
<a onclick="reduceLength(30);return false;"><button class="btn btn-warning btn-sm" style="vertical-align: inherit; ">D-30</button></a-->
<p style="font-size:13px;">
  ※주의사항<br />
   - 기본설정 검색기간은 7일 입니다.<br />
   <template v-if="currentPage == 'langTrain'">- 언어훈련관 경우 <span style="font-weight:bold; color:#ff0000;">녹음파일 보관기간은 1달(30일)</span>이기 때문에 이전 녹음파일은 재생되지 않을 수 있습니다.<br /></template>

</p>
<table class="table" style="border-top:1px solid #ccc;">
  <colgroup>
    <col style="width:30%;" />
  </colgroup>
  <tr>
    <th>
      기간검색(최대6개월)
    </th>
    <td style="text-align:left; padding-left:40px; vertical-align:middle; padding-top:10px;">
      <input type="date" class="mb-2 form-control" v-model="qgStart" style="display:inline; width:140px; height:36px; border-radius:0; border-color:#ccc;"> ~ <input type="date" class="mb-2 form-control" v-model="qgEnd" style="display:inline; width:140px; height:36px; border-radius:0; border-color:#ccc;">
    </td>
  </tr>
</table>

</form>
<div v-show="currentPage=='langTrain'" >
             <p style="font-size:14px;">
           - 학습번호를 클릭하시면 학습현황을 확인할 수 있습니다.<br />
           </p>
   <query-grid :config="config" ref="qg_langTrain" >
     <template #resultactions>
<p class="view_title">Language Training</p>
     </template>
     <template #items="props">
       <tr v-for="(record, i) in props.records" :key="i" style="height:46px;">
         <td>{{ record.date }}</td>
         <td><span style="background:#00acea; border:1px solid #007fea;  padding:3px 6px; border-radius:6px;"><a :href="'https://bizstudy.useschool.co.kr/report/report_detail_v1.asp?hno=' + record.hno" target="_blank" style="color:#fff;">{{ record.activity}}</a></span></td>
         <td>{{ record.type }}</td>
         <td>{{ record.studytime }}</td>
         <td>{{ record.alpha }}</td>
         </tr>
    </template>

   </query-grid>
</div>

<div v-show="currentPage=='lang'">

   <query-grid :config="config_langCourse" ref="qg_lang" v-show="currentPage=='lang'">
     <template #resultactions>
<p class="view_title">Language Course</p>
     </template>
     <template #items="props">
       <tr v-for="(record, i) in props.records" :key="i" style="height:46px;">
         <td>{{ record.date }}</td>
          <td>{{ record.grade }}</td>
           <td>{{ record.day }}</td>
           <td>{{ record.subject }}</td>
           <td>{{ record.activity }}</td>
         <td>{{ record.time }}</td>

         <td>{{ record.usscore.split("||")[0] }}</td>
         <td>{{ record.alpha }}</td>
         </tr>
    </template>
   </query-grid>
</div>
<div v-show="currentPage=='regular'">
   <query-grid :config="config_regularCourse" ref="qg_regular" v-show="currentPage=='regular'">
     <template #resultactions>
<p class="view_title">Regular Course</p>
     </template>
     <template #items="props">
       <tr v-for="(record, i) in props.records" :key="i" style="height:46px;">
         <td>{{ record.date }}</td>
          <td>{{ record.grade }}</td>
           <td>{{ record.subject }}</td>
           <td>{{ record.week }} / {{ record.day }}</td>
           <td>{{ record.activity }}</td>
           <td>{{ record.summary }}</td>
         <td>{{ record.time }}</td>

         <td>{{ record.usscore.split("||")[0] }}</td>
         <td>{{ record.alpha }}</td>
         </tr>
    </template>
   </query-grid>
</div>
<div v-show="currentPage=='curri'">
   <query-grid :config="config_curri" ref="qg_curri" v-show="currentPage=='curri'">
     <template #resultactions>
<p class="view_title">Curriculum</p>
     </template>
     <template #items="props">
       <tr v-for="(record, i) in props.records" :key="i" style="height:46px;">
         <td>{{ record.date }}</td>
           <td>{{ record.activity }}</td>
           <td>{{ record.subject }}</td>
           <td>{{ record.summary }}</td>
         <td>{{ record.time }}</td>
         <td>{{ record.alpha }}</td>
         </tr>
    </template>
   </query-grid>
</div>
        </div>
      </div>
    </div>
  </div>
<div class="modal fade ModalAdm" tabindex="-1" role="dialog"
  aria-labelledby="myLargeModalLabel" aria-hidden="true"
  style="background:rgba(0,0,0,0.8);">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">
          학습진도 처리 (관리자용)</h5>
      </div>
      <div class="modal-body">
       <p style="font-size:13px; line-height: 23px;">
         ※주의사항<br />
          - 해당 기능은 학생이 진도를 정상적으로 진행할 수 없을경우에만 사용해 주시기 바랍니다.<br />
          - 해당학습의 Assign(진도현황)을 조절할 수 있으며 Admin 처리한 학습의 경우 점수가 부여되지 않습니다 <br />
          - <span style="font-weight:bold; color:#ff0000;">진행해야 하는 차시보다 더 많은 차시를 체크한경우 수정이 되지 않으니</span> 반드시 정확한 차시를 확인해주시기 바랍니다.<br />
       </p>

        <table class="table">
          <tbody style="border-top:1px solid #d8d8d8;">
            <tr>
              <td class="th_bg">GRADE</td>
              <td>{{ strGrade }}

              </td>
              <td class="th_bg">Subject</td>
              <td>
                {{ strSubject }}
              </td>
            </tr>
            <tr>
              <td colspan="4" style="background:#eee;">
                <div style="background:#246181; color:#fff; padding:6px; margin-bottom:10px;">
                  학습완료로 처리할 DAY를 체크해주세요!</div>
                <div style="text-align: left;">
                  <ul class="admin-ul" style="display: inline-block; background: none; border:none;">
                    <li v-for="(history, index) in acchistorys" v-bind:key="index">
                      <input type="checkbox" v-model="admCheck" :value="index"
                        v-if="!history">
                        <input type="checkbox" disabled checked v-if="history">
                            <span style="font-size:12px; padding:1px 4px; border-radius:2px; margin:4px; background:#00acea; color:#fff;">{{ index }}&nbsp; DAY</span>
                      <span v-if="dhistorys[index]">{{ dhistorys[index].toString().substr(2, 8) }}</span>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
          </tbody>
          <tbody>

          </tbody>
        </table>
        <div class="flex_center">
          <button class="btn btn-danger" @click="AdminAcc()">ADMIN 처리</button>
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click="reSearch()">닫기</button>
        </div>
      </div>

    </div>
  </div>
</div>
<!-- 미modal -->
<div class="modal fade progressModal	" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-modal="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLongTitle">진도현황</h5>
            </div>
            <div class="modal-body">

           <table class="table">
                    <thead>
                      <tr>
                        <td class="th_bg">DATE</td>
                        <td class="th_bg">GRADE</td>
                        <td class="th_bg">Course</td>
                        <td class="th_bg">Subject</td>
                        <td class="th_bg">Progress</td>
                        <td class="th_bg">Status</td>
                        <td class="th_bg">Complete(date)</td>
                        <td class="th_bg">admin</td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="AccData in AccDatas" v-bind:key="AccData.intNo">
                        <td>{{ AccData.datAssign.substr(0, 10) }}</td>
                        <td>{{ AccData.strGrade }}</td>
                        <td>{{ AccData.strCourse }}</td>
                        <td>{{ AccData.strSubject }}</td>
                        <td>{{ AccData.intDone }} / {{ AccData.intTotal }}</td>
                        <td>{{ AccData.strState }}</td>
                        <td><span v-if="AccData.datEnd">{{ AccData.datEnd.substr(0, 10) }}</span>
                        </td>
                        <td>
                          <button class="btn btn-danger btn-sm" data-bs-toggle="modal"
                            :data-bs-target="'#ModalAdm' + TbtnId"
                            @click="getAccDe(AccData.intMemberID, AccData.strGrade, AccData.strCourse, AccData.strSubject)">ADMIN</button>



                        </td>
                      </tr>
                    </tbody>
                  </table>

            </div>
            <div class="modal-footer" style="border-top:none;">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">닫기</button>
            </div>
        </div>
    </div>
</div>
</template>

<script>
  // @ is an alias to /src
  import Tree from "../components/Tree";
  import TreeBtn from "../components/treeBtn";
  import Business from "../components/Business";
  import QueryGrid from "../components/QueryGrid";
  import Student from "../components/detail_pages/Student"
  import printJS from 'print-js'
  import axios from "axios";
  import { Bar } from 'vue-chartjs'
  import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js'

  ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)
  export default {
    name: 'Home',
    components: {
      Bar,
      Tree,
      TreeBtn,
      Business,
      Student,
      QueryGrid
    },
    mounted() {
      if(this.$root.guiPerm !== 'ROOT'){
        this.$refs.qg.search()
        this.config_S.columns = this.config_S.columns.filter(function(el) { return el.id != 'biz'; })
      }

      this.$refs.qg.pushSetting("status_filter_ING", true);

    },
    methods: {
      printIt() {
        printJS({
          printable: 'printThis',
          type: 'html',
          css: ['/print_report.css'],
          scanStyles: false
        })

      },

      initQueryGrid(studentId){
        this.config.extras_addon = async(filter_values, limit, offset) => {
          var extras = "&callback=&cPage=1&old=false&admin_intMemberID=" + studentId;
          if(this.qgStart) extras += "&s_date=" + this.qgStart
          if(this.qgEnd) extras += "&e_date=" + this.qgEnd

          return extras;
        }
        this.config.grid_parser = async(resp) => {
          var data=Function('"use strict";return ' + resp)();
          return {
            records: data.data,
            total: data.totalActivity
          }
        }

          this.config_langCourse.extras_addon = async(filter_values, limit, offset) => {
          var extras = "&callback=&cPage=1&old=false&admin_intMemberID=" + studentId;
          if(this.qgStart) extras += "&s_date=" + this.qgStart
          if(this.qgEnd) extras += "&e_date=" + this.qgEnd

          return extras;
        }
        this.config_langCourse.grid_parser = async(resp) => {
          var data=Function('"use strict";return ' + resp)();
          return {
            records: data.data,
            total: data.totalActivity
          }
        }

                  this.config_regularCourse.extras_addon = async(filter_values, limit, offset) => {
          var extras = "&callback=&cPage=1&old=false&admin_intMemberID=" + studentId;
          if(this.qgStart) extras += "&s_date=" + this.qgStart
          if(this.qgEnd) extras += "&e_date=" + this.qgEnd

          return extras;
        }
        this.config_regularCourse.grid_parser = async(resp) => {
          var data=Function('"use strict";return ' + resp)();
          return {
            records: data.data,
            total: data.totalActivity
          }
        }

                          this.config_curri.extras_addon = async(filter_values, limit, offset) => {
          var extras = "&callback=&cPage=1&old=false&admin_intMemberID=" + studentId;
          if(this.qgStart) extras += "&s_date=" + this.qgStart
          if(this.qgEnd) extras += "&e_date=" + this.qgEnd

          return extras;
        }
        this.config_curri.grid_parser = async(resp) => {
          var data=Function('"use strict";return ' + resp)();
          return {
            records: data.data,
            total: data.totalActivity
          }
        }



        this.$refs.qg_langTrain.search()
        this.$refs.qg_curri.search()
        this.$refs.qg_lang.search()
        this.$refs.qg_regular.search()
      },
      selectedSearchBiz(biz) {
        console.log(biz)
        this.searchBiz = biz;
        this.search();
      },
      search(reset) {
        if (reset) this.offset = 0;
        var extras = "?limit=5&offset=" + this.offset
        if (this.searchBiz && this.searchBiz) {
          extras += "&business=" + JSON.stringify(this.searchBiz)
        }
        if (this.searchKeyword) {
          extras += "&search=" + this.searchKeyword
        }
        axios.get('/studies/american' + extras).then((response) => {
          if (response.data.error) {
            $.notify({
              // options
              message: '데이터를 조회할 수 없습니다. ' + response.data.error
            }, {
              // settings
              type: 'danger',
              z_index: 9999
            });
          } else {
            this.records = response.data.result;
            this.total = response.data.total;
            console.log(this.records);
          }
        })
      },
      PutCurrent(reset) {
        if (!this.sDay) {
          $.notify({
            // options
            message: '부여할 학습을 선택하셔야 합니다. '
          }, {
            // settings
            type: 'danger',
            z_index: 9999
          });
          return;
        }
        if (!this.hopeStop) {
          $.notify({
            // options
            message: '부여할 기간을 선택하셔야 합니다. '
          }, {
            // settings
            type: 'danger',
            z_index: 9999
          });
          return;
        }

        var today = new Date();

        var year = today.getFullYear();
        var month = ('0' + (today.getMonth() + 1)).slice(-2);
        var day = ('0' + today.getDate()).slice(-2);

        var dateString = year + '-' + month  + '-' + day;

        var tmpVal = [];
        tmpVal.push(this.selData.intMemberID);

        axios.post('/studies/amehomesave', {
          'customValue': '1',
          'strGrade': this.selData.strGrade,
          'strCourse': this.selData.strCourse,
          'strSubject': this.selData.strSubject,
          'classselected': this.selData.classselected,
          'sDay': this.sDay,
          'tmpVal': tmpVal,
          'datAssign': dateString,
          'hopeStop': this.hopeStop
        }).then((response) => {
          if (response.data.error) {
            $.notify({
              // options
              message: '숙제를 부여 할 수 없습니다. ' + response.data.error
            }, {
              // settings
              type: 'danger',
              z_index: 9999
            });
          } else {
            $.notify({
              // options
              message: '숙제를 부여하였습니다.'
            }, {
              // settings
              type: 'success',
              z_index: 9999
            });
          }
        })
      },
      getCurrent(reset, intMemberID, strGrade, strCourse, strSubject, s_name, s_class, intDone, intTotal, classselected) {
        if (reset) {
          this.soffset = 0;
          this.sDay = "";
          this.hopeStop = "";
        }
        axios.post('/studies/americanhome', {
          'intMemberID': intMemberID,
          'strGrade': strGrade,
          'strCourse': strCourse,
          'strSubject': strSubject,
          'limit': 2,
          'offset': this.soffset
        }).then((response) => {
          if (response.data.error) {
            $.notify({
              // options
              message: '데이터를 조회할 수 없습니다. ' + response.data.error
            }, {
              // settings
              type: 'danger',
              z_index: 9999
            });
          } else {
            //console.log(response.data.result);
            this.historys = response.data.result;
            this.stotal = response.data.total;
          }
          //if(reset){
          this.selData = {
            "strGrade": strGrade,
            "strCourse": strCourse,
            "strSubject": strSubject,
            "intMemberID": intMemberID,
            "s_name": s_name,
            "s_class": s_class,
            "intDone": intDone,
            "intTotals": intTotal,
            "classselected": classselected
          }
          //console.log(this.selData)
          //}
        })
      },
      onReport(step, intMemberID, strGrade, strCourse, strSubject, s_name, e_name, s_class, t_name, s_date, e_date, AT_Point, intTotal) {

        //console.log(s_date)

        axios.post('/studies/HomeCount', {
          'intMemberID': intMemberID,
          's_date': s_date,
          'e_date': e_date,
          's_class': s_class.id
        }).then((response) => {
          if (response.data.error) {
            $.notify({
              // options
              message: '데이터를 조회할 수 없습니다. ' + response.data.error
            }, {
              // settings
              type: 'danger',
              z_index: 9999
            });
          } else {
            this.total_A = response.data.total_A;
            this.total_L = response.data.total_L;
            this.total_AW = response.data.total_AW;
            this.total_LW = response.data.total_LW;

            var tmpVal = ((this.total_AW + this.total_LW) / (this.total_A + this.total_L)) * 100;

          }
          this.ReportData = {
            "step": step,
            "strGrade": strGrade,
            "strCourse": strCourse,
            "strSubject": strSubject,
            "intMemberID": intMemberID,
            "s_name": s_name,
            "e_name": e_name,
            "s_class": s_class,
            "t_name": t_name,
            "s_date": s_date,
            "e_date": e_date,
            "AT_Point": AT_Point,
            "intTotal": intTotal
          }

          this.chartData.datasets[0].data = [100, AT_Point, tmpVal];

          //console.log(s_date)

        })
      },
      DelCurrent(intHWNo) {
        axios.post('/studies/americanDelete', {
          'intHWNo': intHWNo
        }).then((response) => {
          if (response.data.error) {
            $.notify({
              // options
              message: '데이터를 삭제할 수 없습니다. ' + response.data.error
            }, {
              // settings
              type: 'danger',
              z_index: 9999
            });
          } else {
            $.notify({
              // options
              message: '삭제되었습니다. ' + response.data.error
            }, {
              // settings
              type: 'danger',
              z_index: 9999
            });
          }
        })
      },
      onDel(ATnum, ATint, TEST_num) {

        console.log(TEST_num);

        if (!confirm("삭제 하시겠습니까?")) {
          return;
        } else {
            axios.post('/studies/ATDelete', {
            'ATnum': ATnum,
            'ATint': ATint,
            'TEST_num': TEST_num
          }).then((response) => {
            if (response.data.error) {
              $.notify({
                // options
                message: '데이터를 삭제할 수 없습니다. ' + response.data.error
              }, {
                // settings
                type: 'danger',
                z_index: 9999
              });
            } else {
              $.notify({
                // options
                message: '삭제되었습니다. '
              }, {
                // settings
                type: 'danger',
                z_index: 9999
              });

              this.$refs.qg.search()

            }
          })
        }
      },
      reSearch() {
        this.$refs.qg.search()
      },
      getAccDe(intMemberID, strGrade, strCourse, strSubject) {

        this.admCheck.splice(0);

        axios.post('/studentUp', {
          'intMemberID': intMemberID,
          'strGrade': strGrade,
          'strCourse': strCourse,
          'strSubject': strSubject
        }).then((response) => {
          if (response.data.error) {
            $.notify({
              // options
              message: '데이터를 조회할 수 없습니다. ' + response.data.error
            }, {
              // settings
              type: 'danger',
              z_index: 9999
            });
          } else {
            this.acchistorys = response.data.result;
            this.dhistorys = response.data.result_D;
          }

          this.strGrade = strGrade;
          this.strCourse = strCourse;
          this.strSubject = strSubject;
          this.intMemberID = intMemberID;

        })
      },
      Getclasslist(reset){

      axios.get('/homework/languages_add').then((response) => {
          if(response.data.error){
                                $.notify({
            // options
            message: '데이터를 조회할 수 없습니다. ' + response.data.error
            }, {
            // settings
            type: 'danger',
            z_index: 9999
            });
          } else {
            this.classlists = response.data.classlist;
          }
        })

      var today = new Date();

      var year = today.getFullYear();
      var month = ('0' + (today.getMonth() + 1)).slice(-2);
      var day = ('0' + today.getDate()).slice(-2);

      var dateString = year + '-' + month  + '-' + day;

      if(!this.datAssign){
        this.datAssign = dateString;
      }

      if(!this.datEnd){
        this.datEnd = dateString;
      }
    },
    checkedAll(checked) {
        this.allChecked = checked;
        for (let i in this.studentlists) {
              this.studentlists[i].selected = this.allChecked;
          }
    },
    selected (e) {
        for (let i in this.studentlists) {
            if(! this.studentlists[i].selected) {
                this.allChecked = false;
                return;
            } else {
                this.allChecked = true;
            }
        }
    },
    viewStudent(){
      //console.log(this.classselected);
      axios.get('/homework/students/' + this.classselected).then((response) => {
          if(response.data.error){
                                $.notify({
            // options
            message: '데이터를 조회할 수 없습니다. ' + response.data.error
            }, {
            // settings
            type: 'danger',
            z_index: 9999
            });
          } else {
            this.studentlists = response.data.result;
            this.stotal = response.data.total;
            this.allChecked = false;
          }


        })
    },
    onChangeSGrade(reset){
      if(this.sslevel){
        axios.get('/studies/gradelist/' + this.sslevel).then((response) => {
            if (response.data.error) {
              $.notify({
                // options
                message: '데이터를 조회할 수 없습니다. ' + response.data.error
              }, {
                // settings
                type: 'danger',
                z_index: 9999
              });
            } else {
              this.sstrCourses = response.data.result;
              this.sstrSubjects = "";
              this.sstrdays = "";
              this.ssCourse = "";
              this.ssSubject = "";
              this.ssday = "";
              console.log(response.data.result);
            }
        })
        }
        else{
          this.sstrCourses = "";
          this.sstrSubjects = "";
          this.sstrdays = "";
          this.sstrCourses = "";
          this.ssSubject = "";
          this.ssday = "";
        }
    },
    getDeAcc(id, strGrade, strCourse, strSubject) {
      console.log(id);
        axios.post('/get_Deacc', {
          'intMemberID': id,
          'strGrade': strGrade,
          'strCourse': strCourse,
          'strSubject': strSubject
        }).then((response) => {
          if (response.data.error) {
            $.notify({
              // options
              message: '데이터를 조회할 수 없습니다. ' + response.data.error
            }, {
              // settings
              type: 'danger',
              z_index: 9999
            });
          } else {
            this.AccDatas = response.data.acclist;
            console.log(this.AccDatas);
          }
        })
      },
    onChangeSCourse(reset){
      if(this.ssCourse){
      axios.get('/studies/courselist/' + this.ssCourse).then((response) => {
          if (response.data.error) {
            $.notify({
              // options
              message: '데이터를 조회할 수 없습니다. ' + response.data.error
            }, {
              // settings
              type: 'danger',
              z_index: 9999
            });
          } else {
            this.sstrSubjects = response.data.result;
            this.ssSubject = "";
            this.sstrdays = "";
            this.ssday = "";
            console.log(response.data.result);
          }
        })
      }
      else{
        this.sstrSubjects = "";
        this.sstrdays = "";
        this.ssSubject = "";
        this.ssday = "";
      }
    },
    onChangeSSubject(reset){
      if(this.ssSubject){
        axios.get('/studies/daylist/' + this.ssCourse + '/' + this.ssSubject.replaceAll('/','_')).then((response) => {
            if (response.data.error) {
              $.notify({
                // options
                message: '데이터를 조회할 수 없습니다. ' + response.data.error
              }, {
                // settings
                type: 'danger',
                z_index: 9999
              });
            } else {
              this.sstrdays = response.data.result;
              this.ssday = "";
              console.log(response.data.result);
            }
          })
      }
      else{
        this.sstrdays = "";
        this.ssday = "";
      }
    },
    AllPutCurrent(reset){

      if(!this.classselected){
        $.notify({
          // options
          message: '부여할 클래스를 선택하셔야 합니다. '
        }, {
          // settings
          type: 'danger',
          z_index: 9999
        });
        return;
      }

      var tmpVal = [];
      var temStu = [];

      var strLevel = "";
      var intSu = 0;
      var notSu = 0;
      var strmessage = "";
      var strNotmessage = "";

      if(!this.sslevel){
        $.notify({
          // options
          message: '부여할 Grade를 선택하셔야 합니다. '
        }, {
          // settings
          type: 'danger',
          z_index: 9999
        });
        return;
      }

      strLevel = this.sslevel;

      if(this.customValue){

        temStu = this.studentlists;

        $("input[name='tmpChkbox[]']:checked").each(function() {

          if(strLevel == temStu[$(this).val()].level){
            tmpVal.push(temStu[$(this).val()].id);
            intSu = intSu + 1;
          }
          else{
              notSu = notSu + 1;
          }

        });

        if(intSu == 0){
          if(notSu == 0){
            strmessage = '부여할 학생을 선택하셔야 합니다. '
          }
          else{
            strmessage = 'Grade가 맞지 않아 부여할 수 없습니다. '
          }
        }

        console.log(tmpVal.length);
        //return;

        if(tmpVal.length == 0){
          $.notify({
            // options
            message: strmessage
          }, {
            // settings
            type: 'danger',
            z_index: 9999
          });
          return;
        }

      }



      if(!this.ssCourse){
        $.notify({
          // options
          message: '부여할 Grade_2를 선택하셔야 합니다. '
        }, {
          // settings
          type: 'danger',
          z_index: 9999
        });
        return;
      }

      if(!this.ssSubject){
        $.notify({
          // options
          message: '부여할 Subject를 선택하셔야 합니다. '
        }, {
          // settings
          type: 'danger',
          z_index: 9999
        });
        return;
      }

      if(!this.ssday){
        $.notify({
          // options
          message: '부여할 Day를 선택하셔야 합니다. '
        }, {
          // settings
          type: 'danger',
          z_index: 9999
        });
        return;
      }

      axios.post('/studies/amehomesave', {
        'strGrade': this.sslevel,
        'strCourse': this.ssCourse,
        'strSubject': this.ssSubject,
        'sDay': this.ssday,
        'classselected': this.classselected,
        'customValue': this.customValue,
        'tmpVal': tmpVal,
        'datAssign': this.datAssign,
        'hopeStop': this.datEnd
      }).then((response) => {
        if (response.data.error) {
          $.notify({
            // options
            message: '숙제를 부여 할 수 없습니다. ' + response.data.error
          }, {
            // settings
            type: 'danger',
            z_index: 9999
          });
        } else {
          console.log(response.data.result);

          if(notSu >0){
            strNotmessage = '숙제를 부여하였습니다. ' + notSu + '명의 학생은 Grade가 맞지 않아 부여 할 수 없습니다.'
          }
          else{
            strNotmessage = '숙제를 부여하였습니다.'
          }

          $.notify({
              // options
            message: strNotmessage
          }, {
            // settings
            type: 'success',
            z_index: 9999
          });
          this.search(true);
        }
      })

    },
    getAcc(id, strGrade) {
      console.log(strGrade);
        axios.get('/students/get_acc/' + id + '/' + strGrade).then((response) => {
          if (response.data.error) {
            $.notify({
              // options
              message: '데이터를 조회할 수 없습니다. ' + response.data.error
            }, {
              // settings
              type: 'danger',
              z_index: 9999
            });
          } else {
            this.AccDatas = response.data.acclist;
            console.log(this.AccDatas);
          }
        })
      },
      AdminAcc() {
        console.log(this.strGrade);
        axios.post('/privileges', {
          'value': this.admCheck,
          'intMemberID': this.intMemberID,
          'strGrade': this.strGrade,
          'strCourse': this.strCourse,
          'strSubject': this.strSubject
        }).then((response) => {
          if (response.data.error) {
            $.notify({
              // options
              message: 'ADMIN 처리 실패: ' + response.data.error
            }, {
              // settings
              type: 'danger',
              z_index: 9999
            });
          } else {
            this.admCheck.splice(0);
            this.acchistorys = response.data.result;
            this.dhistorys = response.data.result_D;
          }


        })
      },
      viewAT(intHWNo) {
        window.open("https://bizstudy.useschool.co.kr/PLS/AT/R/4result.asp?intNo="+intHWNo, 'windowPop',"width=1400,height=1050,scrollbars=yes", '_blank')
      },
      onMission(intMemberID,report_info) {
        window.open("https://bizstudy.useschool.co.kr/PLS/pls_certificate.asp?admin_intMemberID="+intMemberID+"&report_info="+report_info, 'windowPop',"width=1900,height=1050,scrollbars=yes", '_blank')
      },
      onMission2(intMemberID,report_info) {
        window.open("https://bizstudy.useschool.co.kr/PLS/pls_completion.asp?admin_intMemberID="+intMemberID+"&report_info="+report_info, 'windowPop',"width=1900,height=1050,scrollbars=yes", '_blank')
      }
    },
    data() {
      return {config_S: {
    "disable_init_search": true,
    "name": "학습현황",
    "req_endpoint": "/studies/american_new",
    "default_limit": 20,
    "search_fields": [
        {
            "id": "businesses",
            "name": "소속선택",
            "type": "business" // business, date, datetime,
        },
        {
            "id": "search",
            "name": "키워드검색",
            "type": "text",
            "placeholder": "본부/학원/클래스로 검색"
        },
        {
            "id": "level_filter",
            "name": "학습단계",
            "type": "switch",
            "filter_type": {
                "GK001": "GK001",
                "GK002": "GK002",
                "GK003": "GK003",
                "GK004": "GK004",
                "GK005": "GK005",
                "GK001_1": "GK001_1",
                "GK002_1": "GK002_1",
                "GK003_1": "GK003_1",
                "GK004_1": "GK004_1",
                "GK005_1": "GK005_1",
                "GR101": "GR101",
                "GR102": "GR102",
                "GR103": "GR103",
                "GR104": "GR104",
                "GR105": "GR105",
                "GR106": "GR106",
                "GR201": "GR201",
                "GR202": "GR202",
                "GR203": "GR203",
                "GR204": "GR204",
                "GR205": "GR205",
                "GR206": "GR206",
                "GR301": "GR301",
                "GR302": "GR302",
                "GR303": "GR303",
                "GR304": "GR304",
                "GR401": "GR401",
                "GR402": "GR402",
                "GR403": "GR403",
                "GR404": "GR404"
            }
        },
        {
            "id": "Subject_filter",
            "name": "과목",
            "type": "switch",
            "filter_type": {
                "Language Arts": "Language Arts",
                "plus": "Language Arts_plus",
                "Math": "Math",
                "Science": "Science",
                "Social Studies ": "Social Studies",
                "MA/SS/SC": "MA/SS/SC"
            }
        },
        {
            "id": "status_filter",
            "name": "진행상태",
            "type": "switch",
            "filter_type": {
                "ALL": "ALL",
                "ING": "진행",
                "FINISH": "완성",
                "CANCEL": "취소"
            }
        }
    ],
    "columns": [
        {
            "id": "chkbox",
            "name": "체크",
            "is_check": true,
            "excel_print": false
        },
        {
            "id": "biz",
            "name": "Campus",
            "excel_print": v=>{return v.t2.name}
        },
        {
            "id": "Class",
            "name": "Class",
            "excel_print": v=>{return v.t1.name}
        },
        {
            "id": "ID",
            "name": "ID",
            "excel_print": v=>{return v.username}
        },
        {
            "id": "Name",
            "name": "Name",
            "excel_print": v=>{return v.name}
        },
        {
            "id": "Step",
            "name": "Step",
            "excel_print": v=>{return v.Step}
        },
        {
            "id": "Subject",
            "name": "Subject",
            "excel_print": v=>{return v.strSubject}
        },
        {
            "id": "Progress",
            "name": "Progress",
            "excel_print": v=>{return v.intDone + " / " + v.intTotal}
        },
        {
            "id": "Assignment",
            "name": "Assignment",
            "excel_print": v=>{return v.datAssign}
        },
        {
            "id": "1st",
            "name": "1st",
            "excel_print": v=>{return v.TEST1_S}
        },
        {
            "id": "2nd",
            "name": "2nd",
            "excel_print": v=>{return v.TEST2_S}
        },
        {
            "id": "3rd",
            "name": "3rd",
            "excel_print": v=>{return v.TEST3_S}
        },
        {
            "id": "Detail",
            "name": "Detail"
        },
        {
            "id": "Complete",
            "name": "Complete(date)"
        },
        {
            "id": "Certification",
            "name": "Certification"
        },
        {
            "id": "HomeWork",
            "name": "HomeWork"
        }
    ]
},
config: {
    "name": "학습현황",
    "req_endpoint": "https://bizstudy.useschool.co.kr/Report/retrieveDailyLangTrain.asp",
    "default_limit": 20,
    "columns": [
        {
            "id": "date",
            "name": "Date",
            "excel_print": v=>{return v.date}
        },

        {
            "id": "Activity",
            "name": "Activity",
            "excel_print": v=>{return v.activity}
        },

        {
            "id": "type",
            "name": "type",
            "excel_print": v=>{return v.type}
        },
        {
            "id": "studytime",
            "name": "Study Time",
            "excel_print": v=>{return v.studytime}
        },
        {
            "id": "alpha",
            "name": "Alpha",
            "excel_print": v=>{return v.alpha}
        }
    ]
},
config_langCourse: {
    "name": "학습현황",
    "req_endpoint": "https://bizstudy.useschool.co.kr/Report/retrieveDailyLanguageCourse.asp",
    "default_limit": 20,
    "columns": [
        {
            "id": "date",
            "name": "Date",
            "excel_print": v=>{return v.date}
        },

        {
            "id": "Grade",
            "name": "Grade",
            "excel_print": v=>{return v.grade}
        },
        {
            "id": "Day",
            "name": "Day",
            "excel_print": v=>{return v.day}
        },
        {
            "id": "Subject",
            "name": "Subject",
            "excel_print": v=>{return v.subject}
        },
        {
            "id": "Activity",
            "name": "Activity",
            "excel_print": v=>{return v.activity}
        },
              {
            "id": "Study Time",
            "name": "Study Time",
            "excel_print": v=>{return v.time}
        },
        {
            "id": "Score",
            "name": "Score",
            "excel_print": v=>{return v.usscore == 'NOT FOUND' ? '' : v.usscore.split("||")[0]}
        },
        {
            "id": "alpha",
            "name": "Alpha",
            "excel_print": v=>{return v.alpha}
        }
    ]
},
config_regularCourse: {
    "name": "학습현황",
    "req_endpoint": "https://bizstudy.useschool.co.kr/Report/retrieveDailyRegularCourse.asp",
    "default_limit": 20,
    "columns": [
        {
            "id": "date",
            "name": "Date",
            "excel_print": v=>{return v.date}
        },

        {
            "id": "Grade",
            "name": "Grade",
            "excel_print": v=>{return v.grade}
        },
        {
            "id": "Subject",
            "name": "Subject",
            "excel_print": v=>{return v.subject}
        },
        {
            "id": "day",
            "name": "Week/Day",
            "excel_print": v=>{return v.week + '/' + v.day}
        },
        {
            "id": "Activity",
            "name": "Activity",
            "excel_print": v=>{return v.activity}
        },
                {
            "id": "Summary",
            "name": "Summary",
            "excel_print": v=>{return v.summary}
        },
              {
            "id": "Study Time",
            "name": "Study Time",
            "excel_print": v=>{return v.time}
        },
        {
            "id": "Score",
            "name": "Score",
            "excel_print": v=>{return v.usscore == 'NOT FOUND' ? '' : v.usscore.split("||")[0]}
        },
        {
            "id": "alpha",
            "name": "Alpha",
            "excel_print": v=>{return v.alpha}
        }
    ]
},
config_curri: {
    "name": "학습현황",
    "req_endpoint": "https://bizstudy.useschool.co.kr/Report/retrieveDailyCurri.asp",
    "default_limit": 20,
    "columns": [
        {
            "id": "date",
            "name": "Date",
            "excel_print": v=>{return v.date}
        },

        {
            "id": "Activity",
            "name": "Activity",
            "excel_print": v=>{return v.activity}
        },
        {
            "id": "Subject",
            "name": "Subject",
            "excel_print": v=>{return v.subject}
        },
                {
            "id": "Summary",
            "name": "Summary",
            "excel_print": v=>{return v.summary}
        },
              {
            "id": "Study Time",
            "name": "Study Time",
            "excel_print": v=>{return v.time}
        },
        {
            "id": "alpha",
            "name": "Alpha",
            "excel_print": v=>{return v.alpha}
        }
    ]
},
        currentPage: 'lang',
        records: [],
        selData: {
          "strGrade": "",
          "strCourse": "",
          "strSubject": "",
          "intMemberID": "",
          "s_name": "",
          "s_class": "",
          "intDone": "",
          "intTotals": "",
          "classselected": ""
        },
        ReportData: {
          "step": "",
          "strGrade": "",
          "strCourse": "",
          "strSubject": "",
          "intMemberID": "",
          "s_name": "",
          "e_name": "",
          "s_class": "",
          "t_name": "",
          "s_date": "",
          "e_date": "",
          "AT_Point": "",
          "intTotal": ""
        },
        searchKeyword: "",
        searchBiz: "",
        offset: 0,
        total: 0,
        soffset: 0,
        stotal: 0,
        hopeStop: "",
        sDay: "",
        historys: [],
        acchistorys: [],
        dhistorys: [],
        index: 0,
        qgStart: null,
        qgEnd: null,
        qgStudentId: null,
        classlists: [],
        studentlists: [],
        customValue: '1',
        strSubjects: "",
        sstrSubjects: "",
        sstrdays: "",
        sslevel: "",
        ssCourse: "",
        ssSubject: "",
        ssday: "",
        details: "",
        sstrCourses: "",
        stotal: 0,
        allChecked: false,
        admCheck: [],
        total_A: 0,
			  total_L: 0,
			  total_AW: 0,
			  total_LW: 0,
        chartData: {

        labels: [ 'Progress Report', 'Achievement Test', 'Homework Report' ],
        datasets: [ {
          label:' ',
          data: [98, 60, 68],
          backgroundColor:['rgba(214, 24, 21, 0.5)','rgba(255, 186, 0, 0.5)','rgba(64, 161, 0, 0.5)'],
          borderColor: [
     'rgb(214, 24, 21)',
     'rgb(255, 186, 0)',
     'rgb(64, 161, 0)',],
     borderWidth: 1,





        } ]
      },
      chartOptions: {
        responsive: true,

        plugins: {
                   title: {
                       display: true,
                       text: ' '
                   },

                   legend: {
                                   display: false,

                               }
                 },


      }
      }
    }
    }
</script>
